import { render, staticRenderFns } from "./freeLogin.vue?vue&type=template&id=05587148&scoped=true"
import script from "./freeLogin.vue?vue&type=script&lang=js"
export * from "./freeLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05587148",
  null
  
)

export default component.exports